import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useLayout } from "../core";

const Footer: FC = () => {
	const { classes } = useLayout();
	const navigate = useNavigate();
	return (
		<div className="footer py-4 d-flex flex-lg-column" id="kt_footer">
			{/* begin::Container */}
			<div
				className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-between`}
			>
				{/* begin::Copyright */}
				<div className="text-gray-900 order-2 order-md-1">
					<span className="text-muted fw-bold me-2">
						{new Date().getFullYear()} &copy;
					</span>
					<span className="text-gray-800 text-hover-primary">
						Tamilnadu Government Social Audit. All rights reserved.
					</span>
				</div>
				{/* end::Copyright */}

				{/* begin::Nav */}
				<ul className="menu menu-gray-600 menu-hover-primary fw-bold">
					<li className="menu-item">
						<a onClick={() => navigate("/reach-us")} className="cursor-pointer">
							Reach-us
						</a>
					</li>
				</ul>
				<ul className="menu menu-gray-600 menu-hover-primary fw-bold order-1"></ul>

				{/* end::Nav */}
			</div>
			{/* end::Container */}
		</div>
	);
};

export { Footer };
